import { Button } from '@mui/material';
import React from 'react';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import Gene20Button from '../../../Components/Gene20Button';

export default function LPNavButtons(props) {
  const { auntheticated } = props;
  return (
    <Gene20Box sx={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', p: 2 }}>
      <Button variant="contained" width="50vh">
        join our community
      </Button>
      <Button variant="contained" width="50vh" onClick={auntheticated}>
        visit our stores
      </Button>
    </Gene20Box>
  );
}
